<template>
    <section id="masterMap" class="relative will-change py-10" :data-scroll-section="inner == 'false'">
        <div class="mb-12" v-if="blockData.title">
            <h2 class="text-4xl xl:text-heading text-center tracking-[2px] leading-none px-8  mb-7 w-full" v-html="blockData.title"></h2>
        </div>

        <div class="relative mx-content z-10 h-[67vh] after:block after:absolute after:bg-black after:bg-opacity-30 after:top-0 after:left-0 after:w-full after:h-full after:z-[5] after:pointer-events-none ">

            <!-- map -->
            <div id="map" class="rounded-lg" style="height: 100%;"></div>
            <!-- map -->

            <div class="px-content flex items-center justify-center text-white absolute bottom-10 xl:bottom-16 w-full z-10">
                <div class="hidden xl:flex xl:w-4/12 ">
                    <div class="text-sm xl:w-[90%]" v-show="blockData.text" v-html="blockData.text"></div>
                </div>

                <div class="hidden xl:flex xl:w-4/12">
                    <div class="bg-white bg-opacity-90 rounded text-xs text-navy-blue-02 text-center mx-auto p-5 w-[286px]">
                        {{__('Hover over interest point to view more info', 'ccave')}}
                    </div>
                </div>


                <div class="flex xl:w-4/12 ">
                    <a class="text-white uppercase text-xs flex items-center tracking-little ml-auto" v-show="blockData.cta" :href="blockData.cta.url">
                        {{ blockData.cta.title }}
                        <svg class="ml-6 w-10 xl:w-[60px] h-10 xl:h-[60px]" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="30" cy="30" r="29.5" stroke="white" />
                            <path d="M20 30L39 30" stroke="white" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round" />
                            <path d="M36 26L40 30L36 34" stroke="white" stroke-width="1.2" stroke-linecap="square" />
                        </svg>
                    </a>
                </div>

            </div>

            <div class="absolute bottom-8 left-1/2 -translate-x-1/2 bg-white bg-opacity-90 rounded text-xs text-center px-10 py-5 whitespace-nowrap">
                <span>{{ __('Click on the interest point or zoom in to view more', 'ccave') }}</span>
            </div>
        </div>
        

        <div :class="{ 'xyz-in z-[51] active-card': showSlide, 'xyz-out z-[40]': !showSlide }"
                class="card-toponyms--slide fixed right-0 top-0 bottom-0 z-[51] flex flex-col bg-white shadow-md w-full sm:w-[504px] h-[calc(100vh-66px)] xl:h-[calc(100vh-116px)] overflow-y-auto invisible"  xyz="fade right-100% duration-4" ref="slideCard" data-scroll data-scroll-sticky data-scroll-target="#masterMap">
            <button type="button" @click="showSlide = false; $refs.slideCard.style.visibility = 'invisible'" class="grid xl:hidden place-items-center bg-mid-grey rounded-full cursor-pointer hover:opacity-70 w-10 h-10 absolute right-4 top-4">
                <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="white"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="1" d="M6 18L18 6M6 6l12 12" /></svg>
            </button>
            <div class="pb-10 h-full" v-if="activePoint">
                <div class="overflow-hidden h-[34vh]">
                    <img class="object-cover w-full" :src="activePoint.poi[0].fields.image.sizes.customslide" :alt="activePoint.poi[0].fields.image.alt">
                </div>
                <div class="p-8">
                    <h4 class="text-2xl tracking-[1px] mb-6" >{{ activePoint.poi[0].post_title }}</h4>
                    <div class="text-sm" v-show="activePoint.poi[0].fields.text" v-html="activePoint.poi[0].fields.text"></div>
                </div>
            </div>
        </div>
    </section>
</template>


<script>
import mapboxgl from 'mapbox-gl'
import centerOfMass from '@turf/center-of-mass'

    export default {
        name: 'MasterplanMap',
        data() {
            return {
                activePoint: false,
                showSlide: false,
            }
        },
        mounted() {

            mapboxgl.accessToken = this.blockData.map_data.map_settings.access_token;
            const map = new mapboxgl.Map({
                container: 'map', // container ID
                /* style: this.blockData.map_data.map_settings.style, */ // style URL
                style: 'mapbox://styles/aleksandarstojsin/ckvqeuf2qo9iz15mp3rysmrpd',
                center: this.blockData.map_data.map_settings.center, // starting position
                zoom: this.blockData.map_data.map_settings.zoom, // starting zoom
                pitch: this.blockData.map_data.map_settings.pitch,
                bearing: this.blockData.map_data.map_settings.bearing,
                cooperativeGestures: true,
                attributionControl: false
            });

            map.addControl(new mapboxgl.NavigationControl());

            map.on('load', () => {
                this.blockData.map_data.markers.forEach((marker, index) => {
                    let mapData = JSON.parse(marker.map_data)
                     if ( mapData.geometry.type === 'Polygon' ) {
                        map.addSource('polygon'+index, {
                            'type': 'geojson',
                            'data': mapData
                        })

                        map.addLayer({
                            'id': 'fill'+index,
                            'type': 'fill',
                            'source': 'polygon'+index,
                            'layout': {},
                            'paint': {
                                'fill-color': '#FFF', // mora boja i opacity na nula da bi bilo transparentno, amozda moze i drugacije
                                'fill-opacity': parseFloat(marker.opacity),
                            }
                        });

                        map.addLayer({
                            'id': 'outline'+index,
                            'type': 'line',
                            'source': 'polygon'+index,
                            'layout': {},
                            'paint': {
                                'line-color': '#FFF',
                                'line-width': 2
                            }
                        });
                        var comPt = centerOfMass(mapData);

                        map.addSource('label'+index, {
                            'type': 'geojson',
                            'data': comPt
                        });

                        map.addLayer({
                            'id': 'label-style'+index,
                            'type': 'symbol',
                            'source': 'label'+index,
                            'layout': {
                                'text-field': marker.name,
                                'text-font': ["Canela Regular", "Open Sans Semibold", "Arial Unicode MS Bold"]
                            },
                            'paint': {
                                'text-color': 'white'
                            }
                        });

                    } else {
                        map.loadImage(
                            this.endpoints.template_url + '/assets/img/dot-circle-white.png',
                            (error, image) => {
                                if (error) throw error;
                                map.addImage('custom-marker'+index, image);
                                // Add a GeoJSON source with 2 points
                                map.addSource('points'+index, {
                                    'type': 'geojson',
                                    'data': mapData
                                });

                                // Add a symbol layer
                                map.addLayer({
                                    'id': 'points'+index,
                                    'type': 'symbol',
                                    'source': 'points'+index,
                                    'layout': {
                                        'icon-image': 'custom-marker'+index,
                                        "icon-allow-overlap": true,
                                        // 'text-font': [
                                        //     'Canela',
                                        // ]
                                        // get the title name from the source's "title" property
                                        /* 'text-field': marker.poi[0].post_title,
                                        'text-font': [
                                            'Open Sans Semibold',
                                            'Arial Unicode MS Bold'
                                        ],
                                        'text-offset': [0, 1.25],
                                        'text-anchor': 'top' */
                                    },
                                    /* paint: {
                                        "text-color": "white"
                                    } */
                                });

                                map.on('mousemove', 'points'+index, (e) => {
                                    map.getCanvas().style.cursor = 'pointer';
                                    this.activePoint = this.blockData.map_data.markers[index]
                                    if ( this.$refs.slideCard.classList.contains('invisible') && !this.showSlide ) {
                                        this.$refs.slideCard.style.visibility = 'visible'
                                        this.showSlide = true

                                        let offsetCard
                                        if ( this.$root.isMobile ){
                                            offsetCard = -67 
                                        } else{
                                            offsetCard = -116 
                                        }

                                        this.$root.scroll.scrollTo('#masterMap', {
                                            offset: offsetCard,
                                            duration: 800,
                                            disableLerp: true
                                        })
                                    }
                                });

                                map.on('mouseleave', 'points'+index, () => {
                                    map.getCanvas().style.cursor = '';
                                    this.showSlide = false
                                });
                            }
                        );
                    }


                });
            })
            map.scrollZoom.disable();

        },
        methods: {



        },
    }
</script>
